import { getBridgesTable, getMembersTable } from "data/tables/bridge-structure.js";
import * as React from 'react';
export default {
  getBridgesTable,
  getMembersTable,
  React
};